import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType, imageType} from '../../../utils/commonPropTypes'
import WavyBackground from '../../../components/WavyBackground'
import WidthContainer from '../../../components/WidthContainer'
import {QueryedButton} from '../../../components/Button'
import StarsContainer from '../../../components/Stars'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import {useHighlightOverlay} from '../../../components/HighlightOverlay'

const phoneBreakpoint = '@media only screen and (max-width: 850px)'

const RootContainer = styled(WavyBackground)`
	overflow: hidden;
`
RootContainer.defaultProps = {
	type: 'darkBlue',
}


const InnerContainer = styled.div`
	display: flex;
	padding: 0 0 5rem;
	margin: -2rem;
	position: relative;
	
	> * {
		margin: 2rem;
	}
	
	${phoneBreakpoint} {
		flex-direction: column;
		align-items: stretch;
	}
`

const Column = styled.div`
	flex: 1;
`

const InnerColumn = styled.div`
	max-width: 30rem;
	margin: 0 auto;
`

const AboveTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 1.5rem;
`

const Title = styled.h2`
	font-size: ${props => props.theme.fontSizes.big40};
`


const Text = styled.div`
	margin: 2.3rem 0 2rem;
`

const Images = styled.div`
	img {
		margin: 0;
	}
`

const BigImageContainer = styled.div`
	margin-bottom: .45rem;	
	> * > * {
		width: 100%;
		height: 12.5rem;
	}
`

const ImagesRow = styled.div`
	display: flex;
	margin: -.45rem;
	
	> * {
		flex: 1;
		margin: .45rem;
	}
	
	> * > * {
		height: 5rem;
		width: 100%:
	}
`

const ImageContainer = styled.div`
	 > * {
	 	display: block;
	 }
`

function PlaceSection({className, data}) {
	const {showOverlay} = useHighlightOverlay()
	const imagesCollection = data.pastImages.images.map(one => one.youtubeUrl ? {youtubeUrl: one.youtubeUrl} : one.full)

	return <RootContainer className={className}>
		<StarsContainer rotate='31deg'/>
		<WidthContainer>
			<InnerContainer>
				<Column>
					<InnerColumn>
						<AboveTitle>{data.aboveName}</AboveTitle>
						<Title>{data.name}</Title>
						<Text>{data.text}</Text>
						<QueryedButton data={data.button}/>
					</InnerColumn>
				</Column>
				<Column>
					<InnerColumn>
						<AboveTitle>{data.pastImages.title}</AboveTitle>
						{data.pastImages.images.length > 0 && <Images>
							<BigImageContainer>
								<ImageContainer onClick={() => showOverlay({
									collection: imagesCollection,
									visibleIndex: 0,
								})}>
									<QueriedGatsbyImage
										image={data.pastImages.images[0].preview}/>
								</ImageContainer>
							</BigImageContainer>
							<ImagesRow>
								{data.pastImages.images.slice(1, 4).map((image, index) => <ImageContainer
									onClick={() => showOverlay({
										collection: imagesCollection,
										visibleIndex: index + 1,
									})}>
									<QueriedGatsbyImage
										key={image.preview.publicURL}
										image={image.preview}/>
								</ImageContainer>)}
							</ImagesRow>
						</Images>}
					</InnerColumn>
				</Column>
			</InnerContainer>
		</WidthContainer>
	</RootContainer>
}

PlaceSection.propTypes = {
	className: PropTypes.string,
}

PlaceSection.defaultProps = {
	className: '',
	data: PropTypes.shape({
		aboveName: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		button: buttonType.isRequired,
		pastImages: PropTypes.shape({
			title: PropTypes.string.isRequired,
			images: PropTypes.arrayOf(PropTypes.shape({
				preview: imageType.isRequired,
				full: imageType.isRequired,
				youtubeUrl: PropTypes.string,
			}).isRequired).isRequired,
		}),
	}).isRequired,
}

export default PlaceSection
